import { render, staticRenderFns } from "./part-a.vue?vue&type=template&id=ac32428e&"
import script from "./part-a.vue?vue&type=script&lang=js&"
export * from "./part-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports